import request from '@/utils/request'

// 查询设备变更日志列表
export function listEquipmentLog(query) {
  return request({
    url: '/system/equipment-log/list',
    method: 'get',
    params: query,
  })
}

// 查询设备变更日志分页
export function pageEquipmentLog(query) {
  return request({
    url: '/system/equipment-log/page',
    method: 'get',
    params: query,
  })
}

// 查询设备变更日志详细
export function getEquipmentLog(data) {
  return request({
    url: '/system/equipment-log/detail',
    method: 'get',
    params: data,
  })
}

// 新增设备变更日志
export function addEquipmentLog(data) {
  return request({
    url: '/system/equipment-log/add',
    method: 'post',
    data: data,
  })
}

// 修改设备变更日志
export function updateEquipmentLog(data) {
  return request({
    url: '/system/equipment-log/edit',
    method: 'post',
    data: data,
  })
}

// 删除设备变更日志
export function delEquipmentLog(data) {
  return request({
    url: '/system/equipment-log/delete',
    method: 'post',
    data: data,
  })
}
